export default __webpack_public_path__ + "static/popup-desktop-x2-53941f38e38d852e3a4aabc19b0a96b4.webp";